function initHeader() {
  const $header = document.querySelector('.shopify-section.shopify-section-group-header-group')
  const $mainHeader = $header.querySelector('header')

  const $is_skin = $header.querySelector('[data-is-skin]').dataset.isSkin

  const buttonActiveClasses =
    $is_skin === 'true'
      ? ['text-purple', '[&_hr]:w-full', '[&_svg]:text-purple', '[&_svg]:rotate-90']
      : ['text-red', '[&_hr]:w-full', '[&_svg]:text-red', '[&_svg]:rotate-90']

  // Mobile Menu
  const $mobileMenuButton = $header.querySelector('button[data-mobile-menu]')
  const $mobileMenu = $header.querySelector('nav[data-mobile-menu]')
  const $mobileMenuBackdrop = $header.querySelector('[data-mobile-menu-backdrop]')
  const $$expandableButtons = $mobileMenu.querySelectorAll('button[data-expandable]')

  const mobileMenuButtonClasses = ['[&_path]:translate-x-0', '[&_path]:translate-y-0', '[&_path]:rotate-0']

  const openMobileMenu = () => {
    document.body.classList.add('mobile-menu-open')
    $mobileMenu.style.setProperty(
      'padding-top',
      $mainHeader.offsetHeight + $mainHeader.getBoundingClientRect().top + 'px'
    )
    $mobileMenu.classList.remove('hidden')
    setTimeout(() => {
      $mobileMenu.classList.remove('-translate-x-full')
    }, 0)
    document.body.classList.add('overflow-hidden')
    $mobileMenuBackdrop.classList.remove('pointer-events-none')
    $mobileMenuBackdrop.classList.add('opacity-40')
    mobileMenuButtonClasses.forEach((className) => $mobileMenuButton.classList.toggle(className))
    trapFocus(document.querySelector('nav[data-mobile-menu]'), document.querySelector('nav[data-mobile-menu]'), true)
  }

  const closeMobileMenu = () => {
    $mobileMenu.classList.add('-translate-x-full')
    document.body.classList.remove('overflow-hidden')
    $mobileMenuBackdrop.classList.add('pointer-events-none')
    $mobileMenuBackdrop.classList.remove('opacity-40')
    mobileMenuButtonClasses.forEach((className) => $mobileMenuButton.classList.toggle(className))
    removeTrapFocus()
    setTimeout(() => {
      $mobileMenu.classList.add('hidden')
      document.body.classList.remove('mobile-menu-open')
    }, 350)
  }

  $mobileMenuButton.addEventListener('click', () => {
    if ($mobileMenu.classList.contains('-translate-x-full')) {
      openMobileMenu()
    } else {
      closeMobileMenu()
    }
  })

  $mobileMenuBackdrop.addEventListener('click', () => closeMobileMenu())

  $$expandableButtons.forEach(($button) => {
    $button.addEventListener('click', () => {
      const $expandable = $button.nextElementSibling
      if ($expandable.classList.contains('!grid-rows-[1fr]')) {
        $expandable.classList.remove('!grid-rows-[1fr]')
        $button.classList.remove(...buttonActiveClasses)
        $expandable.classList.add('invisible')
        $expandable.classList.remove('visible')
      } else {
        $expandable.classList.add('!grid-rows-[1fr]')
        $button.classList.add(...buttonActiveClasses)
        $expandable.classList.remove('invisible')
        $expandable.classList.add('visible')
      }
    })
  })

  class StickyHeader extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.header = $header
      this.mobileMenu = this.header.querySelector('nav[data-mobile-menu]')
      this.is_skin = $is_skin
      this.announcementBarContainers = $header.querySelectorAll('[data-announcement-bar-container]')
      // this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      //// Dev Settings
      // Always keep header sticky at top of page
      this.headerIsAlwaysSticky = true
      this.preventHide = false

      // Prevents announcement bar from hiding when scrolling up
      if (document.querySelector('#page-sticky-header-slot').dataset.activeStickyNav !== 'true') {
        this.preventHide = true
      } else {
        this.replaceATCButton()
      }

      this.headerBounds = {}

      this.setHeaderHeight()

      window.matchMedia('(max-width: 1023px)').addEventListener('change', this.setHeaderHeight.bind(this))

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('sticky', 'top-0')
      }

      this.currentScrollTop = 0
      this.preventReveal = false
      //this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this)
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.addEventListener('scroll', this.onScrollHandler, false)

      this.createObserver()
    }

    replaceATCButton() {
      // Create iRestore Hair/Skin link element
      const alt_button_link = document.createElement('a')
      alt_button_link.className = `ir-button ml-3 flex items-center justify-center !px-5 !py-2 max-xl:hidden [&[data-loading]>[data-loader]]:block [&[data-loading]>[data-text]]:invisible`
      let alt_button_color_className = ``
      if (this.is_skin === 'true') {
        alt_button_color_className = `color-scheme-707dcb69-da00-4026-958a-05a2f47794a8 normal-case`
        alt_button_link.href = '/pages/skin-quiz'
        alt_button_link.textContent = 'TAKE SKIN QUIZ'
      } else {
        alt_button_color_className = `color-background-1 normal-case`
        alt_button_link.href = '/pages/hair-loss-quiz'
        alt_button_link.textContent = 'TAKE HAIR QUIZ'
      }

      alt_button_link.className = `${alt_button_link.className} ${alt_button_color_className}`

      // Replace the existing button with the new link
      const existingButton = this.header.querySelector('.ir-button[data-add-to-cart]')
      if (existingButton) {
        existingButton.replaceWith(alt_button_link)
      }
    }

    mountSlot() {
      this.stickySlotElement = this.header.querySelector('#page-sticky-header-slot > div')
      this.disconnectedCallback()
      this.connectedCallback()
    }

    setHeaderHeight(e) {
      //  document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
      if (e && !e.matches) {
        // console.log(e)
        document.body.classList.remove('overflow-hidden')
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
      window.removeEventListener('scroll', this.onScrollHandler)
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect
        observer.disconnect()
      })

      observer.observe(this.header)
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      //if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let scrolled_down_condition = false
      let scrolled_up_condition = false

      const $mainAtc = document.querySelector('[id^="MainProduct"] device-product-form [data-add-to-cart]')

      if ($mainAtc) {
        if ($mainAtc.getBoundingClientRect().bottom < -100) {
          scrolled_down_condition = true
        } else if ($mainAtc.getBoundingClientRect().bottom > -100) {
          scrolled_up_condition = true
        }
      } else {
        const $firstSection = document.querySelector('main .shopify-section')
        if ($firstSection && $firstSection.getBoundingClientRect().bottom < -100) {
          scrolled_down_condition = true
        } else if ($firstSection && $firstSection.getBoundingClientRect().bottom > -100) {
          scrolled_up_condition = true
        }
      }

      if (scrolled_down_condition) {
        if (this.preventHide) return

        // Only apply shifting if NOT on a PDP with sticky nav (pdp-sticky-nav handles its own fade)
        const hasStickyNav = document.querySelector('#page-sticky-header-slot')?.dataset.activeStickyNav === 'true'
        if (!hasStickyNav) {
          this.header.style.setProperty('margin-top', 'calc(-1 * var(--announcement-bar-height))')
          this.header.style.setProperty('transform', 'translateY(calc(-1 * var(--announcement-bar-height)))')
          this.mobileMenu.classList.add('translate-y-[var(--announcement-bar-height)]')
        }

        requestAnimationFrame(this.hide.bind(this))
      } else if (scrolled_up_condition) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this))

          this.header.style.setProperty('margin-top', '')
          this.header.style.setProperty('transform', '')
          this.mobileMenu.classList.remove('translate-y-[var(--announcement-bar-height)]')
        } else {
          window.clearTimeout(this.isScrolling)

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false
          }, 66)

          // Only apply shifting if NOT on a PDP with sticky nav
          const hasStickyNav = document.querySelector('#page-sticky-header-slot')?.dataset.activeStickyNav === 'true'
          if (!hasStickyNav) {
            this.header.style.setProperty('margin-top', 'calc(-1 * var(--announcement-bar-height))')
            this.header.style.setProperty('transform', 'translateY(calc(-1 * var(--announcement-bar-height)))')
          }
          this.mobileMenu.classList.remove('translate-y-[var(--announcement-bar-height)]')
          requestAnimationFrame(this.hide.bind(this))
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this))
      }

      this.currentScrollTop = scrollTop
    }

    hide() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('-translate-y-full', 'sticky', 'top-0')
      if (this.stickySlotElement) this.stickySlotElement.classList.add('translate-y-full')
      this.closeMenuDisclosure()
      this.dispatchEvent(new CustomEvent('sticky-header:hidden'))
      //this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return
      this.header.classList.add('sticky', 'top-0', 'animate')
      this.header.classList.remove('-translate-y-full')
      if (this.stickySlotElement) this.stickySlotElement.classList.remove('translate-y-full')
    }

    reset() {
      if (this.headerIsAlwaysSticky) return

      this.header.style.setProperty('margin-top', '')
      this.header.style.setProperty('transform', '')
      this.mobileMenu.classList.remove('translate-y-[var(--announcement-bar-height)]')

      this.header.classList.remove('-translate-y-full', 'sticky', 'top-0', 'animate')
      if (this.stickySlotElement) this.stickySlotElement.classList.remove('translate-y-full')
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')
      this.disclosures.forEach((disclosure) => disclosure.close())
    }

    /* closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    } */
  }

  customElements.define('sticky-header', StickyHeader)
}

initHeader()

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('shopify-section-group-header-group')) {
      initHeader()
    }
  })
}

window.addEventListener('load', () => {
  if (window.location.hash.length > 0) {
    const $el = document.querySelector(window.location.hash)
    if ($el) {
      window.scrollTo({ top: $el.offsetTop - 100, behavior: 'smooth' })
    }
  }
})

// Resize observer for nav
const $navContainer = document.querySelector('.shopify-section.shopify-section-group-header-group')
const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.target === $navContainer) {
      const height = entry.contentRect.height
      const announcementBarHeight = document.querySelector('[data-announcement-bar-container]').offsetHeight
      document.documentElement.style.setProperty('--header-height', `${height}px`)
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`)
    }
  })
})

resizeObserver.observe($navContainer)
